export default "__VITE_ASSET__lPyCYiCs__"